import { platformPartners } from '@/mocks/home';

export default function PartnerShowcase() {
  return (
    <section className="py-12 md:py-16" aria-label="合作伙伴">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            合作伙伴
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            携手优质平台，打造高清免费影视大全
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
          {platformPartners.map((partner) => (
            <div
              key={partner.id}
              className="flex flex-col items-center text-center p-6 md:p-8 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full ${partner.color} text-background-50 mb-4`}>
                <i className={`${partner.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2">
                {partner.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {partner.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}